export const REGISTRATION_SUBMITTED_COPY = {
  title: 'Registration Submitted',
  body:
    'RotationStreet conducts strict background verification so every member can find deals more efficiently. We will notify your registered email within three business days whether your account has been approved for login.',
  emailHint: 'We will contact you at:',
  cta: 'Back to Log In',
}
